import { render, staticRenderFns } from "./PrescriptionTemplate.vue?vue&type=template&id=0265483e&scoped=true"
import script from "./PrescriptionTemplate.vue?vue&type=script&lang=js"
export * from "./PrescriptionTemplate.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionTemplate.vue?vue&type=style&index=0&id=0265483e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0265483e",
  null
  
)

export default component.exports